module.exports = "/images/long-arrow-right.svg?2258c8d18625145dfaac9bc707d48c43";